<template>
  <div class="footer-container">
    <footer class="footer">
      <div v-if="!isMobile">
        <!-- <span class="logo-text">Eventstaden</span> -->
        <img src="../assets/logo-din-stad-1.png" class="logo-with-text-image" />
      </div>

      <!-- Middle Section: Links -->
      <nav class="footer-links">
        <a href="#" @click="showNewsLetter">Få nyhetsbrev</a>
        <!-- <a hreflogo-din-stad-1></a> -->
        <!-- <a href="#">Integritet</a> -->
      </nav>

      <!-- Right Section: Feedback Button and Social Icons -->
      <div class="footer-actions">
        <div class="social-icons">
          <a href="https://www.facebook.com/EVENTSTADEN?mibextid=wwXIfr&rdid=2GRrjrPIBG6sYrUz&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F18WtwAx1ZZ%2F%3Fmibextid%3DwwXIfr#"
            target="_blank"><i class="fab fa-facebook-f"></i></a>
          <a href="https://www.tiktok.com/@eventstaden?_t=ZN-8tON2msAS6Y&_r=1&fbclid=IwY2xjawIExeVleHRuA2FlbQIxMAABHU1_jaYFBb5WdQ4qaLnSvnEAIQ1If1-XZhySUY64VGmYjFGpeG0yiezDIw_aem_pSfv76oJypoOu-2lFxARDQ"
            target="_blank"><i class="fab fa-tiktok"></i></a>
          <a href="https://www.linkedin.com/company/eventstaden/?fbclid=IwY2xjawIExgJleHRuA2FlbQIxMAABHe47nkch9CDnZaW86qYjR4H6c0kHjFRSucnGhNlyscuSZKSN06R9NTvAUg_aem_Cy9InfnlCjwrcde_gRKMMQ"
            target="_blank"><i class="fab fa-linkedin-in"></i></a>
          <a href="https://www.instagram.com/eventstaden?igsh=MWxpemJ6YjE1djF1eQ%3D%3D&utm_source=qr&fbclid=IwY2xjawIExWBleHRuA2FlbQIxMAABHQ4Ccbnyc1dUaezfNoC15FVaGtBhgGxSiZ6INHjIkAhweznLZeuHvog9lw_aem_nFZvGo_bE-kViSXSCc0Cbw"
            target="_blank"><i class="fab fa-instagram"></i></a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { EventBus } from '../api/EventBusMixin';

export default {
  name: "EventstadenFotter",
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    }
  },
  methods: {
    showNewsLetter() {
      EventBus.emit("showNewsLetter");
    }
  }
};
</script>

<style scoped>
.footer-container {
  padding-top: 80px;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #141313;
  border-top: 0.01em solid rgba(0, 0, 0, 0.5);
  font-size: 14px;
  color: #333;
  height: 60px;
}

.logo-with-text-image {
  height: 80px;
  /* Adjust size as needed */
  margin-right: 10px;
}

/* Links Section */
.footer-links {
  display: flex;
  gap: 20px;
}

.footer-links a {
  text-decoration: none;
  color: white;
  font-weight: 400;
  transition: color 0.2s ease;
}

/* Actions Section */
.footer-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* Social Icons */
.social-icons {
  display: flex;
  gap: 15px;
  /* Adds space between icons */
}

.social-icons a {
  color: white;
  /* Makes the icons white */
  text-decoration: none;
  font-size: 18px;
  transition: color 0.2s ease, transform 0.2s ease;
  /* Smooth hover effect */
}

.social-icons a:hover {
  transform: scale(1.1);
}
</style>